import { connect } from 'react-redux'
import ATS from 'modules/ATS/index.js'
import {
  addNewRound,
  updateNewRound,
  updateCandidateRoleStatus,
  bulkUploadForAts,
  getPreviewData,
  resolveConflict,
  getCandidateDegree,
  getCandidateDepart,
  getCandidateSpecialization,
  StudentEmailList
} from 'modules/ATS/action.js'
import { getExportFiledData } from '../../JobRoles/actions'

import { getMetrics, getCandidate } from '../../JobRoles/NewJobRole/actions'
import selectors from 'modules/ATS/selector.js'
import { atsExportCandidate, getPreview, statusFilterList,corporateFilterList,studentFilterList } from '../action'
import {
  getJobRolePreview,
  getPlacementHistoryList,
  getStudentPlacedList,
} from '../../JobPreview/action'
import selector from '../../JobPreview/selector'
import { resumeBulkDownload, resumeBulkDownloadJobRoles } from '../../Placement/action'
const mapStateToProps = state => ({
  roundData: selectors.getRoundData(state),
  updateRoundData: selectors.updatedRoundData(state),
  instituteCampusId: state.auth.instituteDetails.id,
  previewData: selectors.getPreviewData(state),
  jobRolePreviewData: selector.getJobRolePreview(state),
})

const mapDispatchToProps = {
  addNewRound,
  updateNewRound,
  getMetrics,
  getCandidate,
  updateCandidateRoleStatus,
  bulkUploadForAts,
  getPreviewData,
  resolveConflict,
  getCandidateDegree,
  getCandidateDepart,
  getExportFiledData,
  atsExportCandidate,
  getPreview,
  getPlacementHistoryList,
  getJobRolePreview,
  getStudentPlacedList,
  statusFilterList,
  corporateFilterList,
  studentFilterList,  
  resumeBulkDownload,
  resumeBulkDownloadJobRoles,
  getCandidateSpecialization,
  StudentEmailList
}

export default connect(mapStateToProps, mapDispatchToProps)(ATS)
